import { Location, LocationGetAllResponse } from '@quromedical/models';
import { ColumnType } from 'components/table';
import { Text } from 'design-system';
import React from 'react';
import { strings } from 'strings';

import { getDescription } from '../cards';

type OmitTypeLocation = Omit<Location, 'type'> & { type: string };

export type LocationTable = Partial<OmitTypeLocation>;

export const columns: ColumnType<LocationTable>[] = [
  {
    header: strings.LocationTableNameSubheading,
    Cell: ({ value }) => <Text>{value}</Text>,
    accessor: 'name',
  } as ColumnType<LocationTable, 'name'>,
  {
    header: strings.LabelLocationType,
    Cell: ({ value }) => <Text>{value}</Text>,
    accessor: 'type',
  } as ColumnType<LocationTable, 'type'>,
  {
    header: strings.LocationStatus,
    Cell: ({ value }) => <Text>{value}</Text>,
    accessor: 'status',
  } as ColumnType<LocationTable, 'status'>,
  {
    header: strings.LocationTableParentSubheading,
    Cell: ({ value }) => <Text>{value?.display || strings.DefaultLocationParent}</Text>,
    accessor: 'parent',
  } as ColumnType<LocationTable, 'parent'>,
  {
    header: strings.LocationTableOrganizationSubheading,
    Cell: ({ value }) => <Text>{value?.display || strings.DefaultLocationOrganization}</Text>,
    accessor: 'managingOrganization',
  } as ColumnType<LocationTable, 'managingOrganization'>,
];

export const getLocationDataFromResponse = (
  res: LocationGetAllResponse
): Partial<LocationTable>[] =>
  res.locations.map(location => ({ ...location, type: getDescription(location.type) }));
